import { createAction } from 'redux-actions';

// eslint-disable-next-line import/prefer-default-export
export const createNotificationAction = createAction('REFORAL_CREATE_NOTIFICATION');
export const getNotificationAction = createAction('REFORAL_GET_NOTIFICATION');
